
import React, { useEffect, useState } from "react";
import { Variables, variables } from '../../Variables.js';
import imageLogo from '../../img/logo.png';

function TeamNameHeader(props) {

    const queryParameters = new URLSearchParams(window.location.search)
    const id = queryParameters.get("playerId")
    const playerName = queryParameters.get("playerName")
    const teamName = queryParameters.get("teamName")

    return (

        <div>
             <ul>
                <li className="stat-list">
                    <div className="propOptions">
                        <h1>{playerName} Stats vs {teamName}</h1>
                     
                        {!props.data && <h2>Sorry, Not Enough Data is Available</h2> }

                        <br></br>
                        <br></br>
                    </div>
                </li>
            </ul>
        </div>
          
     
    )

};

export default TeamNameHeader;